/** Axis label spacing, days. */
const AXIS_STEP_DAYS = 7;
/** A step label nearer to the last day than this share of the axis width is dropped (it would crowd «Сегодня»). */
const MIN_SHARE_TO_TODAY = 0.1;

const DAY_LABEL = new Intl.DateTimeFormat('ru-RU', {
  day: 'numeric',
  month: 'short',
  timeZone: 'UTC',
});

export interface AxisTick {
  index: number;
  /** «1 окт»; `null` marks the last day («Сегодня», translated by the tile). */
  label: string | null;
}

const dayLabel = (key: string): string =>
  DAY_LABEL.format(new Date(`${key}T00:00:00Z`)).replace(/\.$/, '');

/** Every 7th day from the start, then the last day as «Сегодня». */
export const axisTicks = (dayKeys: readonly string[]): AxisTick[] => {
  const lastIndex = dayKeys.length - 1;
  if (lastIndex < 0) return [];
  const ticks: AxisTick[] = [];
  for (
    let i = 0;
    i < lastIndex && (lastIndex - i) / lastIndex >= MIN_SHARE_TO_TODAY;
    i += AXIS_STEP_DAYS
  ) {
    ticks.push({ index: i, label: dayLabel(dayKeys[i] as string) });
  }
  ticks.push({ index: lastIndex, label: null });
  return ticks;
};

/** Horizontal share (0..1) of day `index` among `count` days, as the chart line spaces its points; one day sits at the right edge. */
export const tickFraction = (index: number, count: number): number =>
  count > 1 ? index / (count - 1) : 1;
